import { Dispatch } from "@reduxjs/toolkit";

import { IProduct } from "../../models/catalogue.interfaces";
import { ITileID } from "../../models/product-compare";
import { ICompareTile } from "../../models/product-compare.interfaces";
import { Action } from "./constants";
import {
    IAction,
    IActionAddToSelected,
    IActionCollapseTray,
    IActionExpandTray,
    IActionHideModal,
    IActionRemoveFromSelected,
    IActionSetCompareTiles,
    IActionSetRootProducts,
    IActionShowModal,
    IActionUpdatePriceSelectValue,
} from "./reducers.interfaces";

export class Dispatchers {
    dispatch: Dispatch<IAction>;

    constructor(dispatch: Dispatch<IAction>) {
        this.dispatch = dispatch;
    }

    public readonly setCompareTiles = (tiles: ICompareTile[]): void => {
        this.dispatch<IActionSetCompareTiles>({
            type: Action.SET_COMPARE_TILES,
            payload: {
                tiles: tiles,
            },
        });
    };

    public readonly addToSelected = (tileID: ITileID): void => {
        this.dispatch<IActionAddToSelected>({
            type: Action.ADD_TO_SELECTED,
            payload: {
                tileID: tileID,
            },
        });
    };

    public readonly removeFromSelected = (tileID: ITileID): void => {
        this.dispatch<IActionRemoveFromSelected>({
            type: Action.REMOVE_FROM_SELECTED,
            payload: {
                tileID: tileID,
            },
        });
    };

    public readonly updatePriceSelectValue = (value: string): void => {
        this.dispatch<IActionUpdatePriceSelectValue>({
            type: Action.UPDATE_PRICE_SELECT_VALUE,
            payload: {
                value: value,
            },
        });
    };

    public readonly collapseTray = (): void => {
        this.dispatch<IActionCollapseTray>({
            type: Action.COLLAPSE_TRAY,
        });
    };

    public readonly expandTray = (): void => {
        this.dispatch<IActionExpandTray>({
            type: Action.EXPAND_TRAY,
        });
    };

    public readonly showModal = (): void => {
        this.dispatch<IActionShowModal>({
            type: Action.SHOW_MODAL,
        });
    };

    public readonly hideModal = (): void => {
        this.dispatch<IActionHideModal>({
            type: Action.HIDE_MODAL,
        });
    };

    public readonly setRootProducts = (rootProducts: IProduct[]): void => {
        this.dispatch<IActionSetRootProducts>({
            type: Action.SET_ROOT_PRODUCTS,
            payload: {
                rootProducts: rootProducts,
            },
        });
    };
}
